import FiltrationPage from 'Components/Courses/CourseFiltration/FiltrationPage';

export function FiltrationView() {
  return <FiltrationPage />;
}
